import React from 'react';
import { Hero } from '../components/Hero';
import { ClassFormats } from '../components/ClassFormats';
import { WhyDesertSage } from '../components/WhyDesertSage';
import { Testimonials } from '../components/Testimonials';
import { SupportCTA } from '../components/SupportCTA';
import { ListenInsteadOfReading } from '../components/ListenInsteadOfReading';
export function HomePage() {
  return <>
      <Hero data-id="element-912" />
      <ClassFormats data-id="element-913" />
      <WhyDesertSage data-id="element-914" />
      <Testimonials data-id="element-915" />
      <SupportCTA data-id="element-916" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" data-id="element-917">
        <ListenInsteadOfReading data-id="element-918" />
      </div>
    </>;
}